var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainTitleBold',{class:{ 'error-title': !_vm.underDev },attrs:{"center":""}},[(_vm.underDev)?_c('span',[_vm._v(" "+_vm._s(_vm.undeDevString)+", перезагрузите страницу ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }